export enum KeyId {
  Test = "test",
  PersoV2 = "persov2",
  LedgerRootV3 = "ledger_root_v3",
  PluginSelectorKey = "plugin_selector_key",
  NftMetadataKey = "nft_metadata_key",
  TokenMetadataKey = "token_metadata_key",
  PartnerMetadataKey = "partner_metadata_key",
  Erc20MetadataKey = "erc20_metadata_key",
  DomainMetadataKey = "domain_metadata_key",
  CalCalldataKey = "cal_calldata_key",
  CalTrustedNameKey = "cal_trusted_name_key",
  CalNetwork = "cal_network",
  CalGatedSigning = "cal_gated_signing",
  SwapTemplateKey = "swap_template_key",
}
